import React from "react";
import { Form, InputGroup } from "react-bootstrap";

const BannerInput = ({
  banner,
  setBanner,
  bannerType,
  setBannerType,
  radioReadOnly = false,
  inputReadOnly = false,
}) => {
  const MAX_BANNER_LENGTH = 100;

  return (
    <>
      <div className="mb-2">
        <Form.Check
          type="radio"
          label="None"
          name="bannerType"
          id="none"
          checked={bannerType === "none"}
          disabled={radioReadOnly}
          onChange={() => setBannerType("none")}
        />
        <Form.Check
          type="radio"
          label="Standard banner"
          name="bannerType"
          id="standard"
          checked={bannerType === "standard"}
          disabled={radioReadOnly}
          onChange={() => setBannerType("standard")}
        />
        <Form.Check
          type="radio"
          label="Custom"
          name="bannerType"
          id="custom"
          checked={bannerType === "custom"}
          disabled={radioReadOnly}
          onChange={() => setBannerType("custom")}
        />
      </div>
      {bannerType != "none" && (
        <InputGroup>
          <Form.Control
            as="textarea"
            disabled={inputReadOnly}
            name="policy_announcement[banner]"
            placeholder="Enter banner text"
            maxLength={MAX_BANNER_LENGTH}
            value={banner}
            onChange={(e) => setBanner(e.target.value)}
            aria-describedby="banner-charcount"
          />
          {bannerType == "custom" ? (
            <InputGroup.Text id="banner-charcount" className="text-muted">
              {banner.length}/{MAX_BANNER_LENGTH}
            </InputGroup.Text>
          ) : null}
        </InputGroup>
      )}
    </>
  );
};

export default BannerInput;
